// Animated tab title with a running car — plays once, then settles to the real title
export const animateTitle = () => {
  const finalTitle = "Cotx.es";
  const car = "🚗";
  const smoke = "💨";
  const road = ".";
  const maxPosition = 12;
  let position = maxPosition;

  const interval = setInterval(() => {
    if (position >= 0) {
      const roadBefore = road.repeat(position);
      const roadAfter = road.repeat(Math.max(0, maxPosition - position));
      document.title = `${roadBefore}${car}${smoke}${roadAfter}`;
      position--;
    } else {
      clearInterval(interval);
      document.title = finalTitle;
    }
  }, 80);
};

